import { createAsyncThunk } from "@reduxjs/toolkit";
import { endpoints } from "../../../api/endpoints";
import { ICreateJobResponse } from "../../../api/types/jobs/ICreateJobResponse";
import { IJobParams } from "../../../api/types/jobs/IJobParams";
import { JobStatus } from "../../../api/types/jobs/JobStatus";
import { RootState } from "../../rootState";
import { withJobParentId } from "./utils/withJobParentId";

export const createJobFromTemplate = createAsyncThunk<
  ICreateJobResponse,
  IJobParams,
  { state: RootState }
>("jobs/createNew", async (params, thunkAPI) => {
  const jobParams = withJobParentId(params, thunkAPI.getState());
  const response = await endpoints.job.create(
    { ...jobParams, status: JobStatus.pending },
    thunkAPI.signal,
  );
  if (response.jobID) {
    return response;
  }
  throw new Error(response?.error ?? `Не удалось запустить задачу "${params.name}"`);
});
